module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/team/chris-perry-e55ea04864b3fecf4cc424b6f15c210b.jpg";